<template>
    <div class="GoodDetails">
        <Header ref="headRef"></Header>
        <main class="detail-container" v-loading="loading" element-loading-text="正在加载商品">
            <div v-if="errorMessage" class="detail-state" role="alert">
                <p>{{ errorMessage }}</p>
                <el-button type="primary" @click="getGoodDetails($route.query.id)">重新加载</el-button>
            </div>
            <template v-else-if="good">
                <div class="shop_wrap">
                    <div class="banner_wrap">
                        <el-image v-if="coverImg" class="banner_img" :src="coverImg" fit="contain" :alt="good.goodsName">
                            <div slot="error" class="image-placeholder">暂无商品图片</div>
                        </el-image>
                        <div v-else class="image-placeholder">暂无商品图片</div>
                    </div>
                    <div class="shop_pane">
                        <h1 class="course_title">{{ good.goodsName }}</h1>
                        <div class="courseTeacherList" v-if="good.teacherList.length">
                            <img v-for="(teacher, teacherIndex) in good.teacherList" :key="teacherIndex"
                                :src="teacher.avatarUrl" :alt="teacher.name" class="courseTeacherImg">
                        </div>
                        <div v-for="(specGroup, specGroupIndex) in good.specGroupList" :key="specGroupIndex">
                            <div class="type">{{ specGroup.specName }}</div>
                            <ul class="tag_list">
                                <li v-for="(specItem, specIndex) in specGroup.specList" :key="specIndex">
                                    <button type="button" class="tag" :class="{ active: spec && specItem.specId === spec.specId }"
                                        :aria-pressed="!!spec && specItem.specId === spec.specId" @click="chooseSpec(specItem)">
                                        {{ specItem.specAttribute }}
                                    </button>
                                </li>
                            </ul>
                        </div>
                        <p v-if="!spec" class="empty-content">暂无可购买规格</p>
                        <div class="price_area">
                            <div class="price_wrap">
                                <template v-if="spec">
                                    <span class="unit">￥</span>
                                    <span class="price">{{ (spec.price / 100).toFixed(2) }}</span>
                                    <span class="unit">元</span>
                                </template>
                                <span v-else>暂无报价</span>
                            </div>
                            <el-button type="danger" :disabled="!spec" @click="goOrderDet">立即购买</el-button>
                        </div>
                    </div>
                </div>
                <section class="detail-tabs">
                    <el-tabs v-model="activeName">
                        <el-tab-pane label="详情" name="first">
                            <div v-if="good.goodsDetails" class="goods-rich-text" v-html="good.goodsDetails"></div>
                            <p v-else class="empty-content">暂无商品详情</p>
                        </el-tab-pane>
                        <el-tab-pane label="讲师" name="second">
                            <router-link v-for="(teacher, index) in good.teacherList" :key="index" class="teacherItem"
                                :to="{ path: '/teacher/det', query: { id: teacher.teacherId } }">
                                <div class="teacherImg"><img :src="teacher.avatarUrl" :alt="teacher.name"></div>
                                <div class="teacherContent">
                                    <div class="teacherName">{{ teacher.name }}</div>
                                    <div class="teacherDescription">{{ teacher.intro }}</div>
                                </div>
                            </router-link>
                            <p v-if="!good.teacherList.length" class="empty-content">暂无讲师信息</p>
                        </el-tab-pane>
                    </el-tabs>
                </section>
            </template>
        </main>
        <Suspension class="detail-support"></Suspension>
        <Footer></Footer>
    </div>
</template>

<script>
import Header from '../../components/common/Header'
import Footer from '../../components/common/Footer'
import Suspension from '../../components/common/Suspension'
import { getByParam } from '@/api/api.js'
import { getCookie, setLocalStorage } from '@/utils/util.js'

export default {
    name: 'GoodDetails',
    components: { Header, Footer, Suspension },
    data() {
        return {
            good: null,
            spec: null,
            activeName: 'first',
            loading: false,
            errorMessage: ''
        }
    },
    computed: {
        coverImg() {
            if (!this.good) return ''
            const photo = this.good.photos.find(item => item && item.url)
            return photo ? photo.url : this.good.coverImg || ''
        }
    },
    watch: {
        '$route.query.id': {
            immediate: true,
            handler(id) {
                this.getGoodDetails(id)
            }
        }
    },
    methods: {
        chooseSpec(item) {
            this.spec = item
        },
        goOrderDet() {
            if (this.loading || !this.good || !this.spec) return
            if (getCookie('token')) {
                setLocalStorage('goodInfo', JSON.stringify({ ...this.good, chooseSpec: this.spec }))
                this.$router.push({ path: '/order/det' })
            } else {
                this.$refs.headRef.showLogin()
            }
        },
        async getGoodDetails(id) {
            this.good = null
            this.spec = null
            this.activeName = 'first'
            this.errorMessage = ''
            this.loading = false
            if (!id) {
                this.errorMessage = '缺少商品信息，请从课程列表重新进入'
                return
            }
            this.loading = true
            try {
                const res = await getByParam('/web/mall/goods/detail', { goodsId: id })
                if (id !== this.$route.query.id) return
                if (!res.data || !res.data.goodsId) {
                    this.errorMessage = '商品不存在或已下架'
                    return
                }
                this.good = {
                    ...res.data,
                    photos: res.data.photos || [],
                    teacherList: res.data.teacherList || [],
                    specGroupList: res.data.specGroupList || []
                }
                const group = this.good.specGroupList.find(item => item.specList && item.specList.length)
                this.spec = group ? group.specList[0] : null
            } catch (error) {
                if (id === this.$route.query.id) this.errorMessage = '商品加载失败，请稍后重试'
            } finally {
                if (id === this.$route.query.id) this.loading = false
            }
        }
    }
}
</script>

<style scoped>
.GoodDetails {
    display: flex;
    flex-direction: column;
    min-height: 100vh;
    color: #2b2e33;
}

.detail-container {
    box-sizing: border-box;
    flex: 1;
    width: 100%;
    max-width: 1048px;
    min-height: 360px;
    margin: 0 auto;
    padding: 30px 24px;
}

.shop_wrap {
    display: grid;
    grid-template-columns: minmax(0, 480fr) minmax(0, 490fr);
    align-items: start;
    gap: 30px;
}

.banner_wrap {
    position: relative;
    padding-top: 56.25%;
    overflow: hidden;
    border-radius: 8px;
    background: #f0f2f5;
}

.banner_img,
.banner_wrap > .image-placeholder {
    position: absolute;
    inset: 0;
    width: 100%;
    height: 100%;
}

.image-placeholder {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
    height: 100%;
    color: #737780;
}

.shop_pane,
.teacherContent {
    min-width: 0;
}

.course_title {
    font-size: 18px;
    line-height: 1.6;
    font-weight: 700;
    overflow-wrap: anywhere;
}

.courseTeacherList {
    display: flex;
    flex-wrap: wrap;
    gap: 12px;
    margin-top: 12px;
}

.courseTeacherImg {
    width: 44px;
    height: 44px;
    border-radius: 50%;
    object-fit: cover;
}

.type {
    margin-top: 20px;
    font-size: 14px;
    font-weight: 700;
    line-height: 1.5;
    overflow-wrap: anywhere;
}

.tag_list {
    display: flex;
    flex-wrap: wrap;
    gap: 10px;
    margin-top: 10px;
}

.tag_list li {
    max-width: 100%;
    min-width: 0;
}

.tag {
    box-sizing: border-box;
    max-width: 100%;
    min-height: 36px;
    padding: 7px 12px;
    border: 1px solid #d9d9d9;
    border-radius: 8px;
    background: #f7f7f7;
    color: #61656d;
    font-family: inherit;
    font-size: 12px;
    line-height: 20px;
    text-align: left;
    overflow-wrap: anywhere;
    cursor: pointer;
}

.tag.active {
    border-color: #f2460c;
    background: #f2460c;
    color: #fff;
}

.tag:focus-visible,
.teacherItem:focus-visible {
    outline: 2px solid #399df6;
    outline-offset: 3px;
}

.price_area {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    justify-content: space-between;
    gap: 12px;
    margin-top: 24px;
    padding: 12px;
    border-radius: 8px;
    background: #f7f7f7;
}

.price_wrap {
    color: #f2460c;
    overflow-wrap: anywhere;
}

.unit {
    font-size: 12px;
    font-weight: 600;
}

.price {
    font-size: 24px;
    font-weight: 600;
}

.detail-tabs {
    min-width: 0;
    margin-top: 30px;
}

/* v-html 内的历史内容没有 scoped 属性，需要穿透约束宽度。 */
.goods-rich-text {
    max-width: 100%;
    overflow-x: auto;
    overflow-wrap: anywhere;
    line-height: 1.8;
}

.goods-rich-text ::v-deep * {
    box-sizing: border-box;
    max-width: 100% !important;
    min-width: 0 !important;
}

.goods-rich-text ::v-deep img,
.goods-rich-text ::v-deep video {
    height: auto !important;
    vertical-align: middle;
}

.goods-rich-text ::v-deep table {
    table-layout: fixed;
    overflow-wrap: anywhere;
}

.teacherItem {
    display: flex;
    gap: 24px;
    align-items: flex-start;
    margin-top: 20px;
    padding: 24px;
    border: 1px solid #ededed;
    border-radius: 10px;
    background: #fff;
}

.teacherImg {
    flex-shrink: 0;
    width: 120px;
    height: 120px;
    overflow: hidden;
    border-radius: 50%;
}

.teacherImg img {
    display: block;
    width: 100%;
    height: 100%;
    object-fit: cover;
}

.teacherName {
    margin-bottom: 8px;
    font-size: 18px;
    font-weight: 600;
    line-height: 1.6;
    overflow-wrap: anywhere;
}

.teacherDescription {
    line-height: 1.8;
    white-space: pre-line;
    overflow-wrap: anywhere;
}

.empty-content,
.detail-state {
    padding: 30px 0;
    color: #737780;
    text-align: center;
    line-height: 1.8;
}

.detail-state .el-button {
    margin-top: 16px;
}

@media (max-width: 1199px) {
    .detail-support ::v-deep .sidebar {
        position: static;
        display: flex;
        justify-content: center;
        gap: 24px;
        width: max-content;
        max-width: 100%;
        margin: 0 auto 24px;
    }

    .detail-support ::v-deep .sidebar > .item {
        margin-top: 0 !important;
    }
}

@media (max-width: 767px) {
    .detail-container {
        padding: 20px 16px;
    }

    .shop_wrap {
        grid-template-columns: minmax(0, 1fr);
        gap: 20px;
    }

    .tag {
        min-height: 44px;
    }

    .teacherItem {
        gap: 16px;
        padding: 16px;
    }

    .teacherImg {
        width: 64px;
        height: 64px;
    }

    /* 仅在详情页适配公共头尾和登录框，不影响其他页面。 */
    .GoodDetails ::v-deep .header-box {
        height: auto;
    }

    .GoodDetails ::v-deep .header {
        position: static;
        height: auto;
    }

    .GoodDetails ::v-deep .header .content {
        display: flex;
        flex-wrap: wrap;
        justify-content: center;
        overflow: visible;
    }

    .GoodDetails ::v-deep .header .content .logo {
        width: 100%;
        height: 54px;
        margin-right: 0;
        line-height: 54px;
        text-align: center;
    }

    .GoodDetails ::v-deep .header .login-bar {
        display: flex;
        flex-wrap: wrap;
        justify-content: center;
        align-items: center;
        gap: 8px 12px;
        height: auto;
        padding: 0 12px 12px;
    }

    .GoodDetails ::v-deep .header .nav {
        display: flex;
        flex-wrap: wrap;
        justify-content: center;
    }

    .GoodDetails ::v-deep .header .nav li {
        height: 44px;
        margin: 0 6px;
        font-size: 14px;
        line-height: 44px;
    }

    .GoodDetails ::v-deep .header .login-bar .login-box {
        margin-top: 0;
    }

    .GoodDetails ::v-deep .el-dialog {
        max-width: calc(100% - 32px);
    }

    .GoodDetails ::v-deep .login > div,
    .GoodDetails ::v-deep .login .el-tabs {
        width: 100% !important;
        margin-left: 0 !important;
    }

    .GoodDetails ::v-deep .login .el-input,
    .GoodDetails ::v-deep .login .el-button {
        max-width: 100%;
    }

    .GoodDetails ::v-deep .footer {
        box-sizing: border-box;
        height: auto;
        padding: 16px;
        line-height: 1.8;
    }
}
</style>
